import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from "@app/services/user.service";
import { User } from 'src/app/models/user';
import { GlobalErrorHandlerService } from "@app/services/global-error-handler.service";
import { NotificationService } from "@app/services/notification.service";
import {MethodsHelper} from "@app/helpers/methods.helper";

@Component({
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {

  user: User = new User();
  errorMessage: string = '';

  constructor(
    private userService: UserService,
    private router: Router,
    private errorService: GlobalErrorHandlerService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
  }
  forgotPassword() {
    this.userService.generateOTP(this.user.email).subscribe({
      next: (data) => {
        this.notificationService.showSuccessMessage('Successfully changed.', "");
        this.router.navigate(['/login']);
      },
      error: (ex) => {
        if (ex.status == 500) {
          this.errorMessage = "email does not exist";
        }else {
          this.errorMessage = MethodsHelper.generateMessageException(ex);
        }
        this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${this.errorMessage}` + "</p></div>",
            "");
      }
    });
  }
}
